import { useMutation, useQueryClient } from '@tanstack/react-query';
import { settingApi } from '../api/settingApi';
import type { SystemSettingUpdateRequest } from '../types/setting';

/**
 * PATCH /api/eraf/system-settings/{key}
 * On success, invalidates the list and detail queries.
 */
export function useUpdateSetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ key, body }: { key: string; body: SystemSettingUpdateRequest }) =>
      settingApi.update(key, body),
    onSuccess: (_data, { key }) => {
      void queryClient.invalidateQueries({ queryKey: ['system-settings', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['system-settings', 'detail', key] });
    },
  });
}
